export default __webpack_public_path__ + "static/media/dcasearch.b335ccc6.png";